module.exports = __webpack_public_path__ + "static/media/pamain-light.88cb6bce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-light.svg
// module id = ./src/assets/fonts/pamain-light.svg
// module chunks = 6